import { useState } from 'react';
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { Button } from '@/components/ui/button';
import { Routes } from '@/routes/routes';
import {
	AddClientDialog,
	EditClientDialog,
	ViewClientDialog,
} from './components/ClientDialogs';
import { ClientTable } from './components/ClientTable';
import { CLIENT_DATA } from './data/clients';
import type { ClientConfig } from './types';

export default function ClientPage() {
	const [showAdd, setShowAdd] = useState(false);
	const [viewClient, setViewClient] = useState<ClientConfig | null>(null);
	const [editClient, setEditClient] = useState<ClientConfig | null>(null);

	return (
		<div className="flex flex-col">
			<div className="border-b bg-card px-6 py-4">
				<div className="flex items-center justify-between">
					<h1 className="text-xl font-semibold">Connectra Client</h1>
					<Button onClick={() => setShowAdd(true)}>+ Add Config</Button>
				</div>
				<Breadcrumb className="mt-2">
					<BreadcrumbList>
						<BreadcrumbItem>
							<BreadcrumbLink href={Routes.CONNECTRA_ROOT}>
								Connectra
							</BreadcrumbLink>
						</BreadcrumbItem>
						<BreadcrumbSeparator />
						<BreadcrumbItem>Config</BreadcrumbItem>
						<BreadcrumbSeparator />
						<BreadcrumbItem>Client</BreadcrumbItem>
					</BreadcrumbList>
				</Breadcrumb>
			</div>

			<div className="p-6">
				<div className="mb-4 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">
					Warning: Changing these values may impact system stability. Proceed
					only if you understand the configuration.
				</div>

				<ClientTable
					clients={CLIENT_DATA}
					onView={setViewClient}
					onEdit={setEditClient}
				/>

				<div className="mt-3 flex items-center justify-between text-xs text-muted-foreground">
					<span>
						Showing 1–{CLIENT_DATA.length} of {CLIENT_DATA.length}
					</span>
					<span>Page 1 of 1</span>
				</div>
			</div>

			<AddClientDialog open={showAdd} onClose={() => setShowAdd(false)} />

			{viewClient && (
				<ViewClientDialog
					client={viewClient}
					open
					onClose={() => setViewClient(null)}
				/>
			)}

			{editClient && (
				<EditClientDialog
					client={editClient}
					open
					onClose={() => setEditClient(null)}
				/>
			)}
		</div>
	);
}
